import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=daa730d6&scoped=true"
import script from "./ListSkeleton.vue?vue&type=script&lang=js"
export * from "./ListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=daa730d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa730d6",
  null
  
)

export default component.exports